import React, { Fragment } from "react";
import { Col, Row } from "antd";
import Discussion from "./Discussion";

const ViewEvent = ({ isOrg, event, eventId }) => {
  return (
    <Fragment>
      <Row className="rowPadding" justify="center">
        <Col
          xs={{ span: 24, order: 3 }}
          sm={{ span: 24, order: 3 }}
          md={{ span: 24, order: 3 }}
          lg={{ span: 15, order: 2 }}>
          {Object.keys(event).length > 0 && (
            <Discussion event={event} eventId={eventId} isOrg={isOrg} />
          )}
        </Col>
      </Row>
    </Fragment>
  );
};

export default ViewEvent;
